// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'flag-wave-solid';

export const Component = () => (
  <path d='M13.818 1.963v8.813H5.963V.958h6.849c.287 0 .526.096.718.287.192.24.288.48.288.72v-.002Zm6.37 0h-5.412v9.818c0 .24.096.48.287.67a.976.976 0 0 0 .719.288h4.406c.432 0 .767-.144 1.054-.431.288-.288.431-.623.431-1.054V3.448c0-.432-.143-.767-.43-1.054a1.408 1.408 0 0 0-1.055-.432v.001ZM4.957.48c0-.335-.144-.479-.48-.479C4.145 0 4 .144 4 .479v23.563c0 .335.144.48.479.48.335 0 .479-.145.479-.48V.48Z' />
);

export const viewBox = '0 0 25 25';
